module.exports = __webpack_public_path__ + "static/img/software1.d33af039.png";